import { isDevelopment, isProduction } from "../../utils/env";

// eslint-disable-next-line no-nested-ternary
export const WSS_URL = isProduction()
  ? "wss://ws.aevo.xyz"
  : isDevelopment()
    ? "ws://localhost:8081"
    : "wss://ws-testnet.aevo.xyz";
